import { createSelector } from '@ngrx/store';
import type { ApplicationState } from '../../../reducers';

export interface TwoFactorAuthState {
  twoFactorAuthToken: string;
  codeToken: string;
  phone: string;
}

export const initialTwoFactorAuthState: TwoFactorAuthState = {
  twoFactorAuthToken: null,
  codeToken: null,
  phone: null,
};

export const getTwoFactorAuthState = (state: ApplicationState) => state.twoFactorAuth;

export const get2FactorAuthToken = createSelector(getTwoFactorAuthState, (state: TwoFactorAuthState) => state.twoFactorAuthToken);

export const getCodeToken = createSelector(getTwoFactorAuthState, (state: TwoFactorAuthState) => state.codeToken);

export const getPhone = createSelector(getTwoFactorAuthState, (state: TwoFactorAuthState) => state.phone);
